"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./JumpLinks.scss");
var key_press_1 = require("../../../utils/key-press");
/**
 *
 * <style>
 * #JumpLinks-container ul[class*="rsg--list-"]{margin:20px 0;padding:0;}
 * #JumpLinks-container li[class*="rsg--li-"]{display:inline;border:1px solid #ccc;border-radius:12px;}
 * #JumpLinks-container li[class*="rsg--li-"]{background:#d12127;padding:4px 8px;color:#fff;margin-right:16px;}
 * #JumpLinks-container li[class*="rsg--li-"]:last-child{background:#007a3e;}
 * #JumpLinks-container li[class*="rsg--li-"] p{display:inline;color:#fff;}
 * </style>
 * <ul style="">
 * <li style="">Phase - Beta Unreleased</li>
 * <li style="">Approval - Pending</li>
 * </ul>
 *
 * @visibleName JumpLinks
 */
var JumpLinks = /** @class */ (function (_super) {
    __extends(JumpLinks, _super);
    function JumpLinks(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            window.addEventListener("resize", _this.onScreenResize);
            window.addEventListener("scroll", _this.onScroll);
            _this.onScreenResize();
        };
        _this.componentDidUpdate = function (prevProps) {
            if (prevProps.data !== _this.props.data) {
                _this.onScreenResize();
            }
        };
        _this.componentWillUnmount = function () {
            clearTimeout(_this.animationTimeout);
            clearTimeout(_this.scrollingTimeout);
            clearTimeout(_this.scrollIntoViewTimeout);
            clearTimeout(_this.withTransitionTimeout);
            window.removeEventListener("resize", _this.onScreenResize);
            window.addEventListener("scroll", _this.onScroll);
        };
        _this.calcMarginRight = function () {
            var data = _this.props.data;
            var uniqueId = _this.state.uniqueId;
            var alignCenterMargin = _this.calcAlignCenterMargin();
            var viewportWidth = document.getElementsByTagName("body")[0].clientWidth;
            if (_this.jumpLinksOuterContRef) {
                var outerContWidth = _this.jumpLinksOuterContRef.offsetWidth;
                var minMargin_1 = viewportWidth > 1024 ? 64 : viewportWidth > 767 ? 48 : 32;
                var leftFirst = document
                    .getElementById(uniqueId + "-jumplink-0")
                    .getBoundingClientRect().left;
                var leftCont = document
                    .getElementById(uniqueId + "-jumplinksoutercontplaceholder")
                    .getBoundingClientRect().left;
                var testingWidthA = (leftFirst === 0 ? alignCenterMargin : leftFirst) -
                    leftCont +
                    _this.linksRef[0].offsetWidth;
                var testingWidthB = testingWidthA;
                var testingWidthC = testingWidthA;
                for (var i = 1; i < data.length; i++) {
                    testingWidthB += minMargin_1 + _this.linksRef[i].offsetWidth;
                }
                if (testingWidthB < outerContWidth) {
                    _this.setState(function (_a) {
                        var isSticky = _a.isSticky;
                        return ({
                            alignCenterMargin: alignCenterMargin,
                            isFullWidth: false,
                            marginRight: minMargin_1,
                            jumpLinksHeight: viewportWidth > 1024 ? 64 : viewportWidth > 767 ? 56 : 48,
                        });
                    }, _this.resetUnderline);
                    return;
                }
                var stoppingIndex = 0;
                for (var i = 1; i < data.length; i++) {
                    var test_1 = testingWidthC + minMargin_1 + _this.linksRef[i].offsetWidth / 2;
                    if (test_1 > outerContWidth) {
                        stoppingIndex = i - 1;
                        break;
                    }
                    testingWidthC += minMargin_1 + _this.linksRef[i].offsetWidth;
                }
                if (stoppingIndex === 0) {
                    stoppingIndex = data.length - 1;
                }
                testingWidthA += alignCenterMargin;
                for (var i = 1; i <= stoppingIndex; i++) {
                    if (i !== stoppingIndex) {
                        testingWidthA += _this.linksRef[i].offsetWidth;
                    }
                    else {
                        testingWidthA += _this.linksRef[i].offsetWidth / 2 - alignCenterMargin;
                    }
                }
                var marginRight_1 = (outerContWidth - testingWidthA) / stoppingIndex;
                _this.setState(function (_a) {
                    var isSticky = _a.isSticky;
                    return ({
                        alignCenterMargin: alignCenterMargin,
                        isFullWidth: true,
                        marginRight: marginRight_1,
                        jumpLinksHeight: viewportWidth > 1024 ? 64 : viewportWidth > 767 ? 56 : 48,
                    });
                }, _this.resetUnderline);
            }
        };
        _this.calcAlignCenterMargin = function () {
            var uniqueId = _this.state.uniqueId;
            var elA = document.getElementById(uniqueId + "-jumplinkscontplaceholder");
            var elB = document.getElementById(uniqueId + "-jumplinksgridplaceholder");
            if (elA && elB) {
                var stylesA = window.getComputedStyle(elA);
                var stylesB = window.getComputedStyle(elB);
                var padLeftA = stylesA.getPropertyValue("padding-left");
                var padLeftB = stylesB.getPropertyValue("padding-left");
                var padLeftAInt = parseInt(padLeftA.slice(0, padLeftA.length - 2), 10);
                var padLeftBInt = parseInt(padLeftB.slice(0, padLeftB.length - 2), 10);
                return padLeftAInt + padLeftBInt;
            }
            return 0;
        };
        _this.checkIfSticky = function () {
            var _a = _this.state, isSticky = _a.isSticky, uniqueId = _a.uniqueId;
            var el = document.getElementById(isSticky
                ? uniqueId + "-jumplinksoutercontplaceholder"
                : uniqueId + "-jumplinksoutercont");
            if (el) {
                var needsToBeSticky = el.getBoundingClientRect().top < 0;
                if (!isSticky && needsToBeSticky) {
                    _this.setState({ isSticky: true });
                }
                else if (isSticky && !needsToBeSticky) {
                    _this.setState({ isSticky: false });
                }
            }
        };
        _this.moveUnderline = function (i, options) {
            var isPressed = options.isPressed, isSmall = options.isSmall, scrollIntoView = options.scrollIntoView, withFocus = options.withFocus, withSmoothScroll = options.withSmoothScroll, withTransition = options.withTransition;
            var data = _this.props.data;
            var uniqueId = _this.state.uniqueId;
            if (_this.linksRef[i]) {
                var linkWidth = _this.linksRef[i].offsetWidth;
                var underlineWidth_1 = isSmall ? 20 : linkWidth;
                var rowEl = document.getElementById(uniqueId + "-jumplinksrow");
                var linkEl = document.getElementById(uniqueId + "-jumplink-" + i);
                if (rowEl && linkEl) {
                    var leftRow = rowEl.getBoundingClientRect().left;
                    var leftLink = linkEl.getBoundingClientRect().left;
                    var underlineLeftPos_1 = isSmall
                        ? leftLink - leftRow + (linkWidth - 20) / 2
                        : leftLink - leftRow;
                    if (isPressed) {
                        _this.scrollTo(data[i].anchor, withSmoothScroll);
                    }
                    if (withFocus) {
                        _this.linksRef[i].focus();
                    }
                    _this.setState(function (_a) {
                        var selectedIndex = _a.selectedIndex;
                        return ({
                            hoverIndex: i,
                            selectedIndex: isSmall ? selectedIndex : i,
                            underlineLeftPos: underlineLeftPos_1,
                            underlineWidth: underlineWidth_1,
                            withTransition: withTransition,
                        });
                    }, function () {
                        var _a = _this.state, isFullWidth = _a.isFullWidth, stateWithTransition = _a.withTransition;
                        if (isFullWidth && scrollIntoView) {
                            _this.scrollIntoViewTimeout = setTimeout(function () { return _this.scrollIntoView(withTransition); }, 250);
                        }
                        if (!stateWithTransition) {
                            _this.withTransitionTimeout = setTimeout(function () {
                                _this.setState({ withTransition: true });
                            }, 501);
                        }
                    });
                }
            }
        };
        _this.onKeyUp = function (e) {
            var data = _this.props.data;
            var hoverIndex = _this.state.hoverIndex;
            if (key_press_1.KeyPress.tabIsPressed(e) || key_press_1.KeyPress.enterIsPressed(e) || key_press_1.KeyPress.spaceIsPressed(e)) {
                _this.toggleFocus(true);
            }
            if (key_press_1.KeyPress.enterIsPressed(e) || key_press_1.KeyPress.spaceIsPressed(e)) {
                _this.moveUnderline(hoverIndex, {
                    isPressed: true,
                    isSmall: false,
                    scrollIntoView: true,
                    withFocus: false,
                    withSmoothScroll: true,
                    withTransition: true,
                });
            } /*else if (KeyPress.leftArrowIsPressed(e)) {
                if (e.preventDefault) {
                    e.preventDefault();
                }
                this.setState({ showFocus: true });
                this.onFocus((hoverIndex - (1 % data.length)) % data.length);
            } else if (KeyPress.rightArrowIsPressed(e)) {
                if (e.preventDefault) {
                    e.preventDefault();
                }
                this.setState({ showFocus: true });
                this.onFocus((hoverIndex + (1 % data.length)) % data.length);
            }*/
        };
        _this.onFocus = function (index) {
            var selectedIndex = _this.state.selectedIndex;
            _this.moveUnderline(index, {
                isPressed: false,
                isSmall: index !== selectedIndex,
                scrollIntoView: false,
                withFocus: true,
                withSmoothScroll: undefined,
                withTransition: true,
            });
        };
        _this.onMouseOver = function (index) {
            var selectedIndex = _this.state.selectedIndex;
            _this.moveUnderline(index, {
                isPressed: false,
                isSmall: index !== selectedIndex,
                scrollIntoView: false,
                withFocus: false,
                withSmoothScroll: undefined,
                withTransition: true,
            });
        };
        _this.onMouseLeave = function () {
            var selectedIndex = _this.state.selectedIndex;
            _this.moveUnderline(selectedIndex, {
                isPressed: false,
                isSmall: false,
                scrollIntoView: false,
                withFocus: false,
                withSmoothScroll: undefined,
                withTransition: true,
            });
        };
        _this.onMouseUp = function (index) {
            _this.moveUnderline(index, {
                isPressed: true,
                isSmall: false,
                scrollIntoView: true,
                withFocus: false,
                withTransition: true,
                withSmoothScroll: true,
            });
        };
        _this.onScreenResize = function () {
            _this.calcMarginRight();
        };
        _this.onScroll = function () {
            _this.checkIfSticky();
            if (_this.isScrollingTo) {
                clearTimeout(_this.scrollingTimeout);
                _this.scrollingTimeout = setTimeout(function () {
                    _this.updateUnderline();
                    _this.isScrollingTo = false;
                }, 150);
            }
            else {
                _this.updateUnderline();
            }
        };
        _this.resetUnderline = function () {
            var selectedIndex = _this.state.selectedIndex;
            _this.moveUnderline(selectedIndex, {
                isPressed: false,
                isSmall: false,
                scrollIntoView: false,
                withFocus: false,
                withSmoothScroll: undefined,
                withTransition: false,
            });
        };
        _this.scrollIntoView = function (withTransition) {
            var data = _this.props.data;
            var _a = _this.state, alignCenterMargin = _a.alignCenterMargin, selectedIndex = _a.selectedIndex, underlineLeftPos = _a.underlineLeftPos, underlineWidth = _a.underlineWidth, uniqueId = _a.uniqueId;
            var scrollEl = document.getElementById(uniqueId + "-jumplinksrow");
            var scrollLeft = scrollEl.scrollLeft;
            var left = underlineLeftPos;
            var width = underlineWidth;
            var right = left + width;
            var scrollContWidth = _this.jumpLinksRowRef ? _this.jumpLinksRowRef.offsetWidth : 0;
            var scrollToObj = {
                behavior: withTransition ? "smooth" : "auto",
                top: 0,
            };
            if (selectedIndex === data.length - 1) {
                scrollEl.scrollTo(__assign(__assign({}, scrollToObj), { left: scrollEl.scrollLeft = scrollContWidth }));
            }
            else if (left < scrollLeft) {
                scrollEl.scrollTo(__assign(__assign({}, scrollToObj), { left: scrollEl.scrollLeft = left - alignCenterMargin }));
            }
            else if (right > scrollLeft + scrollContWidth) {
                scrollEl.scrollTo(__assign(__assign({}, scrollToObj), { left: left - scrollContWidth + width + alignCenterMargin }));
            }
        };
        _this.scrollTo = function (anchor, withSmoothScroll) {
            var options = _this.props.options;
            var jumpLinksHeight = _this.state.jumpLinksHeight;
            var anchoredSection = document.querySelector("a[name=" + anchor + "]");
            if (anchoredSection) {
                var top_1 = anchoredSection.getBoundingClientRect().top;
                _this.isScrollingTo = true;
                var scrollLoc = (window.pageYOffset || document.documentElement.scrollTop) +
                    top_1 -
                    jumpLinksHeight +
                    (options && options.jumpToOffset ? options.jumpToOffset : 0) +
                    1;
                var supportsNativeSmoothScroll = "scrollBehavior" in document.documentElement.style;
                if ((supportsNativeSmoothScroll && withSmoothScroll) || !withSmoothScroll) {
                    window.scrollTo({
                        left: 0,
                        top: scrollLoc,
                        behavior: withSmoothScroll ? "smooth" : "auto",
                    });
                }
                else {
                    var duration = Math.sqrt(Math.abs(Math.abs(scrollLoc) -
                        Math.abs(window.pageYOffset || document.documentElement.scrollTop))) * 15;
                    _this.smoothScrollTo(scrollLoc, duration);
                }
            }
        };
        // polyfilled smooth scrolling for IE, Edge & Safari
        _this.smoothScrollTo = function (to, duration) {
            var element = document.scrollingElement || document.documentElement;
            var start = element.scrollTop;
            var change = to - start;
            var startDate = +new Date();
            // t = current time
            // b = start value
            // c = change in value
            // d = duration
            var easeInOutQuad = function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) {
                    return (c / 2) * t * t + b;
                }
                t--;
                return (-c / 2) * (t * (t - 2) - 1) + b;
            };
            var animateScroll = function () {
                var currentDate = +new Date();
                var currentTime = currentDate - startDate;
                element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration).toString(), 10);
                if (currentTime < duration) {
                    requestAnimationFrame(animateScroll);
                }
                else {
                    element.scrollTop = to;
                }
            };
            animateScroll();
        };
        _this.toggleFocus = function (showFocus) {
            _this.setState({ showFocus: showFocus });
        };
        _this.updateUnderline = function () {
            var _a = _this.props, data = _a.data, options = _a.options;
            var jumpLinksHeight = _this.state.jumpLinksHeight;
            for (var i = data.length - 1; i >= 0; i--) {
                var testAnchor = data[i].anchor;
                var anchoredSection = document.querySelector("a[name=" + testAnchor + "]");
                if (anchoredSection) {
                    var top_2 = anchoredSection.getBoundingClientRect().top;
                    var anchorLoc = top_2 -
                        jumpLinksHeight +
                        (options && options.jumpToOffset ? options.jumpToOffset : 0);
                    if (anchorLoc < 0) {
                        _this.moveUnderline(i, {
                            isPressed: false,
                            isSmall: false,
                            scrollIntoView: false,
                            withFocus: false,
                            withSmoothScroll: true,
                            withTransition: true,
                        });
                        return;
                    }
                }
            }
        };
        _this.renderUnderline = function () {
            var _a = _this.state, underlineLeftPos = _a.underlineLeftPos, underlineWidth = _a.underlineWidth, withTransition = _a.withTransition;
            return (React.createElement("div", { className: "" + styles.jumpLinksUnderline + (withTransition ? " " + styles.jumpLinksUnderlineTransition : "") + " absolute bg-cobalt", style: {
                    marginLeft: 0,
                    left: underlineLeftPos,
                    width: underlineWidth,
                } }));
        };
        _this.render = function () {
            var _a = _this.props, data = _a.data, options = _a.options, testId = _a.testId;
            var _b = _this.state, alignCenterMargin = _b.alignCenterMargin, hoverIndex = _b.hoverIndex, isSticky = _b.isSticky, jumpLinksHeight = _b.jumpLinksHeight, marginRight = _b.marginRight, selectedIndex = _b.selectedIndex, showFocus = _b.showFocus, uniqueId = _b.uniqueId;
            return (React.createElement("div", { "data-testid": testId },
                React.createElement("div", { className: "" + (options && options.className ? options.className : "") + (isSticky && options && options.classNameSticky
                        ? " " + options.classNameSticky
                        : ""), id: uniqueId + "-jumplinksoutercontplaceholder", ref: function (ref) { return (_this.jumpLinksOuterContPlaceholderRef = ref); }, style: __assign(__assign({ height: jumpLinksHeight }, (options && options.styleOuter ? options.styleOuter : {})), (isSticky && options && options.styleOuterSticky
                        ? options.styleOuterSticky
                        : {})) },
                    React.createElement("div", { className: "container" + (options && options.classNameInner
                            ? " " + (options && options.classNameInner)
                            : ""), id: uniqueId + "-jumplinkscontplaceholder", style: __assign(__assign({}, (options && options.styleInner ? options.styleInner : {})), (isSticky && options && options.styleInnerSticky
                            ? options.styleInnerSticky
                            : {})) },
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "grid-col-12", id: uniqueId + "-jumplinksgridplaceholder" })))),
                React.createElement("div", { className: "flex flex-items-center bg-rgba-white-85 " + (options &&
                        options.className) + (isSticky
                        ? " " + styles.jumpLinksOuterContSticky + (options && options.classNameSticky
                            ? " " + options.classNameSticky
                            : "") + " top"
                        : ""), id: uniqueId + "-jumplinksoutercont", ref: function (ref) { return (_this.jumpLinksOuterContRef = ref); }, style: __assign(__assign({ height: jumpLinksHeight, marginTop: !isSticky ? -jumpLinksHeight : 0, width: "100%", maxWidth: "100%", marginLeft: "auto", marginRight: "auto", left: 0 }, (options && options.styleOuter ? options.styleOuter : {})), (isSticky && options && options.styleOuterSticky
                        ? options.styleOuterSticky
                        : {})) },
                    React.createElement("div", { className: "container " + styles.jumpLinksCont + " pad-l-none pad-r-none" + (options && options.classNameInner ? " " + options.classNameInner : ""), style: __assign(__assign({}, (options && options.styleInner ? options.styleInner : {})), (isSticky && options && options.styleInnerSticky
                            ? options.styleInnerSticky
                            : {})) },
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "grid-col-12 pad-none" },
                                React.createElement("div", { className: "rel" },
                                    React.createElement("div", { className: styles.jumpLinksRow + " flex overflow-x-auto", id: uniqueId + "-jumplinksrow", onScroll: _this.resetUnderline, ref: function (ref) { return (_this.jumpLinksRowRef = ref); } }, data.map(function (item, index) { return (React.createElement("div", { key: index, style: __assign(__assign(__assign({}, (index === 0 &&
                                            options &&
                                            options.alignment === "center"
                                            ? { marginLeft: "auto" }
                                            : {})), (index === data.length - 1 &&
                                            options &&
                                            options.alignment === "center"
                                            ? { marginRight: "auto" }
                                            : {})), { paddingLeft: index === 0 && alignCenterMargin
                                                ? alignCenterMargin
                                                : 0, paddingRight: index === data.length - 1 &&
                                                alignCenterMargin
                                                ? alignCenterMargin
                                                : 0 }) },
                                        React.createElement("button", { "aria-label": "Jump link to " + item.name + " section (" + (index + 1) + " of " + data.length + ")", className: styles.jumpLinksBtn + " flex flex-items-center font-medium justify-center link-text2 mar-b-none type-base " + (selectedIndex === index
                                                ? styles.jumpLinksBtnBlk
                                                : styles.jumpLinksBtnDkGry), id: uniqueId + "-jumplink-" + index, onFocus: _this.onFocus.bind(null, index), onKeyUp: _this.onKeyUp, onMouseDown: _this.toggleFocus.bind(null, false), onMouseLeave: _this.onMouseLeave, onMouseOver: _this.onMouseOver.bind(null, index), onMouseUp: _this.onMouseUp.bind(null, index), ref: function (ref) { return (_this.linksRef[index] = ref); }, style: {
                                                lineHeight: 1.6,
                                                marginRight: index !== data.length - 1 && marginRight
                                                    ? marginRight
                                                    : 0,
                                            }, tabIndex: 0 },
                                            React.createElement("span", { className: showFocus
                                                    ? styles.jumpLinksBtnInner
                                                    : "" }, item.name)))); })),
                                    _this.renderUnderline())))))));
        };
        _this.state = {
            alignCenterMargin: 0,
            isFullWidth: false,
            isSticky: false,
            jumpLinksHeight: 0,
            hoverIndex: 0,
            marginRight: 0,
            selectedIndex: 0,
            showFocus: true,
            underlineLeftPos: 0,
            underlineWidth: 0,
            uniqueId: props.testId,
            withTransition: false,
        };
        _this.animationTimeout = 0;
        _this.isScrollingTo = false;
        _this.linksRef = [];
        _this.jumpLinksOuterContPlaceholderRef = null;
        _this.jumpLinksOuterContRef = null;
        _this.jumpLinksRowRef = null;
        _this.scrollingTimeout = 0;
        _this.scrollIntoViewTimeout = 0;
        _this.withTransitionTimeout = 0;
        return _this;
    }
    return JumpLinks;
}(React.PureComponent));
exports.default = JumpLinks;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/containers/JumpLinks/JumpLinks.js
// module id = 1844
// module chunks = 8